@if (!isOnFoldersListing) {
  <div class="taxonomy-options">
    <button class="btn-M btn-filled icon-start mb-3" routerLink="/documentos/novo" [disabled]="disableMainButton">
      <i class="far fa-file-plus"></i> <span>{{ 'menu.createDocument' | translate }}</span>
    </button>
    <a routerLink="/documentos/todos" class="taxonomy-option" routerLinkActive="current" [routerLinkActiveOptions]="{ exact: true }">
      <i class="fa-regular fa-file-alt"></i> {{ 'menu.myDocuments' | translate }}</a
    >
    @if (currentUser?.currentPermissions.view_documents_gr) {
      <a routerLink="/documentos/grupo" class="taxonomy-option" routerLinkActive="current" [routerLinkActiveOptions]="{ exact: true }">
        <i class="fa-regular fa-users-class"></i> {{ 'menu.wholeGroup' | translate }}
      </a>
    }
    @if (currentUser?.currentPermissions.view_documents_oz) {
      <a routerLink="/documentos/organizacao" class="taxonomy-option" routerLinkActive="current" [routerLinkActiveOptions]="{ exact: true }">
        <i class="fa-regular fa-users"></i> {{ 'menu.wholeOrganization' | translate }}
      </a>
    }
  </div>
} @else {
  <div class="taxonomy-options">
    <button type="button" class="btn-M btn-filled icon-start" [disabled]="disableMainButton" (click)="newFolderButtonClick.emit()">
      <i class="fa-regular fa-folder-plus"></i> {{ 'menu.newFolder' | translate }}
    </button>
  </div>
}

<hr />

<div class="taxonomy-options especial">
  <div class="taxonomy-subtitle especial">
    {{ 'menu.order' | translate }}
    <div class="taxonomy-custom sort mobile__d-none">
      <div class="pipe"></div>
      <label class="type" title="{{ 'menu.ascending' | translate }}" [class.d-none]="appService.listDirection !== OrderByEnum.Asc">
        <span class="sort-span">{{ 'menu.crescent' | translate }}</span>
        <input type="radio" name="sort-type" class="checked" [(ngModel)]="appService.listDirection" [value]="OrderByEnum.Desc" (ngModelChange)="changeDirection($event)" />
        <i class="fa-solid fa-sort-up"></i>
      </label>
      <label class="type" title="{{ 'menu.descending' | translate }}" [class.d-none]="appService.listDirection !== OrderByEnum.Desc">
        <span class="sort-span">{{ 'menu.decrement' | translate }}</span>
        <input type="radio" name="sort-type" class="checked" [(ngModel)]="appService.listDirection" [value]="OrderByEnum.Asc" (ngModelChange)="changeDirection($event)" />
        <i class="fa-solid fa-sort-down"></i>
      </label>
    </div>
    <div class="taxonomy-custom sort mobile__d-none">
      <div class="pipe"></div>
      <div class="sortBox">
        <label class="type">
          <input type="radio" name="sort-type" [class.checked]="appService.listFormat === ListFormat.List" (click)="changeFormatList(ListFormat.List)" />
          <i class="fa-regular fa-list-ul"></i>
        </label>
        <label class="type">
          <input type="radio" name="sort-type" [class.checked]="appService.listFormat === ListFormat.Box" (click)="changeFormatList(ListFormat.Box)" />
          <i class="fa-regular fa-grip-horizontal"></i>
        </label>
      </div>
    </div>
  </div>
  <div class="taxonomy-custom sort especial">
    <div appDropdown class="taxonomy-custom filter">
      <button
        type="button"
        class="dropdown__toggle-control dropdown__toggle-control--compact dropdown__toggle-control--icon-end dropdown__toggle-control--text-autentigrey-800"
        id="order-filter"
        appDropdownToggle
      >
        {{ listSortings[appService.listSorting] }}
        <i class="fa-regular fa-chevron-down dropdown__toggle-chevron dropdown__toggle-icon--font-size-12"></i>
      </button>
      <div appDropdownMenu aria-labelledby="order-filter">
        @for (sorting of listSortings | keyvalue; track $index) {
          <button type="button" appDropdownItem (click)="changeSorting(sorting.key)">{{ sorting.value }}</button>
        }
      </div>
    </div>
  </div>
  <hr />
  @if (!isOnTrash && !isSearchOpen) {
    <div class="taxonomy-subtitle taxonomy-subtitle--vertical">
      {{ 'menu.filterBy' | translate }}
      <div class="taxonomy-custom sort">
        <div appDropdown class="taxonomy-custom filter">
          <button
            type="button"
            class="dropdown__toggle-control dropdown__toggle-control--compact dropdown__toggle-control--icon-end dropdown__toggle-control--text-autentigrey-800"
            id="status-filter"
            appDropdownToggle
          >
            {{ (appService.documentStatusFilter ? 'documents.statusFilter.' + (appService.documentStatusFilter | lowercase) : 'menu.noFilter') | translate }}
            <i class="fa-regular fa-chevron-down dropdown__toggle-chevron dropdown__toggle-icon--font-size-12"></i>
          </button>
          <div appDropdownMenu aria-labelledby="status-filter">
            <button type="button" appDropdownItem (click)="changeFilter(null)">{{ 'menu.noFilter' | translate }}</button>
            <button type="button" appDropdownItem (click)="changeFilter(documentStatusFilters[1])">
              {{ 'documents.statusFilter.signed' | translate }}
            </button>
            <button type="button" appDropdownItem (click)="changeFilter(documentStatusFilters[0])">
              {{ 'documents.statusFilter.pending' | translate }}
            </button>
            <button type="button" appDropdownItem (click)="changeFilter(documentStatusFilters[2])">
              {{ 'documents.statusFilter.not_signed' | translate }}
            </button>
            <button type="button" appDropdownItem (click)="changeFilter(documentStatusFilters[3])">
              {{ 'documents.statusFilter.rejected' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  }
</div>
@if (currentUser && canShowDocuments() && (!isOnFoldersListing || currentUser.currentPermissions.view_member_folders_oz)) {
  <hr />
  <p class="taxonomy-subtitle">{{ 'menu.organization' | translate }}</p>
  <div class="taxonomy-options">
    <app-search [(query)]="search" theme="clean" (queryChange)="searchRecords(search)" placeholder="{{ 'menu.searchByName' | translate }}"></app-search>

    @for (item of organizationThings; track $index) {
      <a
        class="taxonomy-option light taxonomy-option__bottom"
        [class.d-none]="!canShowDocuments(item)"
        [class.loading]="isLoading"
        [class.current]="['member', 'group'].includes(listPath) && [route.snapshot.params.memberId, route.snapshot.params.groupId].includes(item.id)"
        [routerLink]="recordPath(item)"
        [routerLinkActiveOptions]="{ exact: true }"
        routerLinkActive="current"
      >
        <i class="fas fa-{{ item.type === 'member' ? 'user' : 'users-class' }} taxonomy-option-icon"></i>{{ item.name | truncate: 25 }}
      </a>
    }
  </div>
}
